import React, { createElement } from 'react';
import { Tooltip } from '@mantine/core';
import { Threshold } from '@modules/iot/model';
import Pin, { PinProps } from '@shared/modules/maps/components/Pin';
import { Sensor } from '@modules/sensors/model';

interface SensorPinProps {
  type: Sensor.Type;
  tip?: string;
  level?: Threshold.Level;
  size?: number;
}

function SensorPin<C = 'div'>({
  type,
  tip = 'Sonde',
  level = Threshold.Level.None,
  size,
  ...props
}: SensorPinProps & PinProps<C>) {
  return (
    <Tooltip label={tip} position="top">
      <Pin color={Threshold.levelColor[level]} size={size} {...props}>
        {createElement(Sensor.typeIcon[type], { width: 20, height: 20 })}
      </Pin>
    </Tooltip>
  );
}

export default SensorPin;
